import { MutationTree } from "vuex";

import { UserState } from "@/models/UserState.d.ts";
import { User } from "@/models/User.d.ts";
import { Language } from "@/models/Language.d.ts";
import {getDefaultState} from "./index";

export const mutations: MutationTree<UserState> = {
    setAccessToken(state: UserState, accessToken: string) {
        state.accessToken = accessToken;
    },
    setUserData(state: UserState, user: User) {
        state.user = user;
    },
    setError(state: UserState, error: any) {
        if (error.response){
            state.errorMsg = error.response.data.message;
            state.errorCode = error.response.data.status;
        } else if (error.data){
            state.errorMsg = error.data.message;
            state.errorCode = error.data.status;
        }
    },
    setUserLanguage(state: UserState, language: Language) {
        if (state.user) {
            state.user.language = language;
        }
    },
    setTerms(state: UserState, terms: string) {
        state.terms = terms;
    },
    resetUserState(state: UserState) {
        Object.assign(state, getDefaultState());
    },
    setPlayingVideoState(state: UserState, isPlaying: boolean): void {
        state.isPlayingVideo = isPlaying;
    }
};
